import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();
const { NEXT_PUBLIC_SITE_NAME } = publicRuntimeConfig ?? {};

export const getHeadTitle = title => title || NEXT_PUBLIC_SITE_NAME;
